export const EXTRACT_BEFORE_KEYWORDS = {
    SENIORSHIP: 'SENIORSHIP'
}

export const extractBefore = (message, keyword) => {
    if (!message || !keyword) return null;

    const textBeforeKeyword = message.split(keyword)[0];
    return textBeforeKeyword && textBeforeKeyword !== message
        ? textBeforeKeyword
        : null;
};
